export default __webpack_public_path__ + "static/australian-made-23b8906987a095f5d64f0a7b7fd3638b.svg";